module.exports = __webpack_public_path__ + "static/media/Frame3.223ad7a8.png";